// extracted by mini-css-extract-plugin
export default {"container":"container-80Zxs","favoriteTracksButton":"favoriteTracksButton-4WoTe"};